"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
exports.__esModule = true;
exports.PropertySpecialOfferUpdateDto = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var property_special_offers_days_dto_1 = require("./property-special-offers-days.dto");
var DiscountValueDto = (function () {
    function DiscountValueDto() {
    }
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], DiscountValueDto.prototype, "value");
    __decorate([
        class_validator_1.IsNotEmpty(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], DiscountValueDto.prototype, "type");
    return DiscountValueDto;
}());
var PropertySpecialOfferUpdateDto = (function () {
    function PropertySpecialOfferUpdateDto() {
    }
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], PropertySpecialOfferUpdateDto.prototype, "isActive");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertySpecialOfferUpdateDto.prototype, "type");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsDate(),
        class_transformer_1.Type(function () { return Date; }),
        __metadata("design:type", Date)
    ], PropertySpecialOfferUpdateDto.prototype, "bookingStartDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsDate(),
        class_transformer_1.Type(function () { return Date; }),
        __metadata("design:type", Date)
    ], PropertySpecialOfferUpdateDto.prototype, "bookingEndDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsDate(),
        class_transformer_1.Type(function () { return Date; }),
        __metadata("design:type", Date)
    ], PropertySpecialOfferUpdateDto.prototype, "startDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsDate(),
        class_transformer_1.Type(function () { return Date; }),
        __metadata("design:type", Date)
    ], PropertySpecialOfferUpdateDto.prototype, "endDate");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertySpecialOfferUpdateDto.prototype, "minStay");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertySpecialOfferUpdateDto.prototype, "maxStay");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertySpecialOfferUpdateDto.prototype, "minAge");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertySpecialOfferUpdateDto.prototype, "maxAge");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertySpecialOfferUpdateDto.prototype, "minPeople");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PropertySpecialOfferUpdateDto.prototype, "maxPeople");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return property_special_offers_days_dto_1.PropertySpecialOffersDaysDto; }),
        __metadata("design:type", Array)
    ], PropertySpecialOfferUpdateDto.prototype, "days");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertySpecialOfferUpdateDto.prototype, "calculationType");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertySpecialOfferUpdateDto.prototype, "calculationBase");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", Object)
    ], PropertySpecialOfferUpdateDto.prototype, "applicationType");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return DiscountValueDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", DiscountValueDto)
    ], PropertySpecialOfferUpdateDto.prototype, "purchase");
    __decorate([
        class_validator_1.IsOptional(),
        class_transformer_1.Type(function () { return DiscountValueDto; }),
        class_validator_1.ValidateNested(),
        __metadata("design:type", DiscountValueDto)
    ], PropertySpecialOfferUpdateDto.prototype, "sale");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString({ each: true }),
        __metadata("design:type", Array)
    ], PropertySpecialOfferUpdateDto.prototype, "rooms");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString({ each: true }),
        __metadata("design:type", Object)
    ], PropertySpecialOfferUpdateDto.prototype, "combinable");
    __decorate([
        class_validator_1.IsOptional(),
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], PropertySpecialOfferUpdateDto.prototype, "note");
    return PropertySpecialOfferUpdateDto;
}());
exports.PropertySpecialOfferUpdateDto = PropertySpecialOfferUpdateDto;
//# sourceMappingURL=property-special-offer-update.dto.js.map